import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    type: 'Dev',
    production: false,
    apiUrl: 'https://api.eu-central-1.dev.transformationsfonds.siemens.cloud',
    hash: `${new Date().valueOf()}`,
    msalConfig: {
        auth: {
            clientId: 'c645960d-2524-4c8c-b350-2b39e3c0417d', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['openid', 'profile', 'email', 'offline_access'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.dev.transformationsfonds.siemens.cloud/Api.ReadWrite'], // API permissions to request, here you can add more delegated permissions
            uri: 'https://api.eu-central-1.dev.transformationsfonds.siemens.cloud' // Your backend API URI
        }
    ]
};
